import cn from 'classnames';
import { Drawer, Form, Core } from 'connex-cds';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { View } from './View';
import { useTicketContext } from '../../../TicketContext';

const { DrawerProvider } = Drawer;

const Styled = styled.div`
  .actions {
    margin-top: 20px;
    display: flex;
    //gap: 20px;
    justify-content: flex-end;
  }
`;

export const AddProducts = props => {
  const {
    Components: { MaterialService },
  } = Form.useFormContext();
  const { refreshing: isTicketContextRefreshing, loading: isTicketContextLoading } = useTicketContext();

  const isLoading = useMemo(
    () => props?.isLoading || isTicketContextLoading || isTicketContextRefreshing,
    [props?.isLoading, isTicketContextLoading, isTicketContextRefreshing]
  );

  return (
    <Styled className={cn('add-products')}>
      <Core.Spinner spin={isLoading}>
        <MaterialService>
          <DrawerProvider>
            <View />
          </DrawerProvider>
        </MaterialService>
      </Core.Spinner>
    </Styled>
  );
};
